require('../shared/singleGameService');
require('../shared/singleClipService');
require('./playerSharedDataService');
require('../fhApp/currentUser/currentUser');

'use strict';

angular.module('app.player.playerController', [
  'app.shared.singleGameService',
  'app.shared.singleClipService',
  'app.player.rosterService',
  'app.player.playerSharedDataService',
  'app.currentUser'
])
  .controller('app.player.playerController', [
    '$scope',
    '$interval',
    '$stateParams',
    'app.shared.singleGameService',
    'app.shared.singleClipService',
    '$state',
    '$sce',
    'app.player.rosterService',
    'app.player.playerSharedDataService',
    'currentUser',
    '$rootScope',
    function ($scope, $interval, $stateParams, singleGame, singleClip, $state, $sce, roster,
              playerSharedDataService, currentUser, $rootScope) {
      $scope.apiActivityInterval,
      $scope.selectedAudio = $stateParams.audio;
      $scope.availableStreams = [{Id: '1', Name: 'Home'}];
      $scope.type = $stateParams.type;
      $scope.state = $state;
      $scope.origGameId = $stateParams.id;
      $scope.playerGameId;
      $scope.streamLoadError;
      $scope.game = singleGame;
      $scope.clip = singleClip;
      $scope.roster = roster;
      $scope.lineup = null;
      $scope.isTaggingEvent = false;
      $scope.telestrateToolbox = {
        color: 'blue',
        colorClass: 'video-player__telestrate__color-div__color--blue',
        brush: 'x-small',
        brushClass: 'video-player__telestrate__brush-div__brush--x-small',
        eraser: 'brush',
        eraserClass: 'video-player__telestrate__eraser-div__eraser--medium',
        fillDiameter: 10,
        lastX: 0,
        lastY: 0,
        isClearing: false,
        clearCanvas: false
      };

      let init = function () {

        $scope.apiActivityInterval = $interval(function() {
          const gameId = $scope.playerGameId.toString();
          currentUser.logSessionActivity(gameId);
        }, 60000);

        let authorizeUser = function (game) {
          let template = null;

          if (game) {
            if (!game.can_play) {
              if (currentUser.has_access()) {
                if(!game.has_broadcast && game.blivegameflag > 2) {
                  alert("We apologize but this game has been cancelled and therefore unable to view.");
                } else {
                  template = 'accessDeniedToGame';
                }
              } else {
                template = 'subscriptionRequired';
              }
            }
            else if (game.user_started) {
              template = 'userAlreadyStartedGame';
            }
          }
          else {
            if ($scope.type === 'clip') {
              template = 'accessDeniedToClip';
            } else {
              template = 'accessDeniedToGame';
            }
          }

          if (template) {
            $state.go('app.accessDenied', {
              template: template
            });
          }
        };

        switch ($stateParams.type) {
          case 'game':
            singleGame.retrieve($stateParams.id, {include: ['preroll', 'user_started', 'lineup'], audio: $stateParams.audio})
              .then(function () {
                authorizeUser(singleGame.data);
              });
            break;
          case 'clip':
            singleClip.retrieve($stateParams.id, {include: {game: {include: ['user_started', 'lineup']}}})
              .then(function (response) {
                let data = response.data;
                
                if (data.error) {
                  singleGame.unload();
                  authorizeUser(singleGame.data);
                } else {
                  if (data.game) {
                    singleGame.load(data.game);
                    authorizeUser(singleGame.data);
                  }
                  if($stateParams.clip_edit) {
                    $rootScope.$broadcast('instant_replay_created', {clip: data, show_editor: $stateParams.clip_edit});
                  }
                }
              });
            break;
        }

        playerSharedDataService.getClipCategories();
        playerSharedDataService. getClipSubcategories();

        // $scope.$watch('enableHotKeys', function (enable) {
        //   $scope.$broadcast('enableHotKeys', enable)
        // });

        $scope.$watch('enableGameSpoiler', function (spoiler) {
          $scope.$broadcast('enableGameSpoiler', spoiler);
        });
      };

      $scope.changePlayerFeed = function (type, id) {
        let authorizeUser = function (game) {
          if (game) {
            if (!game.can_play) {
              if(!game.has_broadcast && game.blivegameflag > 2) {
                alert("We apologize but this game has been cancelled and therefore unable to view.");
                $scope.$broadcast('updateLiveLookin', {game: game});
              } else {
                $state.go('app.accessDenied', {
                  template: 'accessDeniedToGame'
                });
              }
            } else if (game.user_started) {
              if (type === 'game') {
                $state.go('app.accessDenied', {
                  template: 'userAlreadyStartedGame'
                });
              }
            } else {
              let audio = type === 'game' && game.pixellot_only ? 4 : null;
              $state.go('.', {id: id, audio: audio});
            }
          } else {
            $state.go('app.accessDenied', {
              template: 'accessDeniedToGame'
            });
          }
        };

        switch (type) {
          case 'game':
            singleGame.retrieve(id, {include: ['preroll', 'user_started']}, false)
              .then(function (response) {
                let data = response.data;
                authorizeUser(data.game);

                /*if(data.game && data.game.blivegameflag <= 2) {
                  singleGame.data = singleGame.load(data.game, data.error);
                }*/
              });
            break;
          case 'clip':
            singleClip.retrieve(id, {include: {game: {include: ['user_started']}}})
              .then(function (response) {
                let data = response.data;

                if (data.game) {
                  //singleGame.load(data.game);
                  authorizeUser(data.game);
                }
              });
            break;
        }
      };

      //$scope.enableHotKeys = true;
      $scope.enableGameSpoiler = false;

      //Watch Game and Boxscore function
      //Pause player when Boxscore clicked. Play when clicking Watch Game.
      $scope.pausePlayer = function(data) {
        let player = $scope.player;
        let playerState = player.getState();
        if (data == true && playerState == 'playing') {
          player.pause(true);
        } else if (data == false && playerState == 'paused') {
          player.play(true);
        }
      };

      // Function for testing ng-repeats in the views
      // Useful for making placeholders
      $scope.returnArrayOfLength = function (num) {
        return new Array(num);
      };

      $scope.setActiveTab = function (num) {

        if (parseInt(num) !== 3) {
          $scope.telestrateToolbox.clearCanvas = true;
        }

        $scope.activeTab = num;
      };

      $scope.playClip = function (clip) {
        let start = singleClip.transformer.getStartTime(clip);
        $scope.player.seek(start);
        singleClip.logWatched(clip);
      };

      $scope.$on("show_hide_clip_details", (event, args) => {
        $scope.isTaggingEvent = args;
        if (!args) {
          if (singleGame.data && !singleGame.data.can_edit) {
            $scope.setActiveTab(2);
          }
        }
      });

      $scope.$on("select_timeline_tab", () => {
          if (singleGame.data && singleGame.data.can_edit && $scope.activeTab !== 1) {
            $scope.tab = '4';
            $scope.setActiveTab(1);
          }
      });

      $scope.$watch(() => {
        return singleGame.data || singleClip.data;
      }, () => {
        if(singleGame.data) {
            if ($stateParams.audio) {
              $scope.selectedAudio = $stateParams.audio;
            } else {
              $scope.selectedAudio = singleGame.data.pixellot_only ? '4' : '1';
            }

            if (singleGame.data.multiple_audio_setting == 1) {
              $scope.availableStreams.push({Id:'2', Name:'Away'});
            } else if (singleGame.data.multiple_audio_setting == 2) {
              $scope.availableStreams.push({Id:'5', Name:'French'});
            }

            $scope.activeTab = $stateParams.activeTab ? $stateParams.activeTab : singleGame.data.can_edit ? 0 : 4;
            if (singleGame.data.iscoringproviderid_fk === 5 || singleGame.data.iscoringproviderid_fk === 7) {
              $scope.tab = '1';
            } else {
              $scope.tab = '2';
            }

            singleGame.getMoreClips();
            $scope.$broadcast('timelineIsAudioVisible');
        } else if (singleClip.data) {
          $scope.activeTab = $stateParams.activeTab ? $stateParams.activeTab : 0;
        }
      });

      $scope.$on('$destroy', () => {
        singleGame.unload();
        singleGame.clips = [];
        singleClip.clear();
        playerSharedDataService.clear();
        $interval.cancel($scope.apiActivityInterval);
      });

      return init();
    }
  ]);



// WEBPACK FOOTER //
// ./app.v2/components/player/playerController.js